export default __webpack_public_path__ + "static/media/oliver-peoples-9.30649667.png";